import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-custom-pagination",
    templateUrl: "./custom-pagination.component.html",
    styleUrls: ["./custom-pagination.component.scss"],
})
export class CustomPagination {
    @Input() totalPages: number = 0;

    @Input() currentPage: number = 1;

    @Input() perPagesList: number[] = [5, 10, 20, 50, 100];

    @Input() itemPerPage: number = 10;

    @Output() pageChange = new EventEmitter<number>();

    @Output() itemsPerPageChange = new EventEmitter<number>();

    @Output() getPageNumbers = new EventEmitter<void>();

    changePage(page: number) {
        if (page < 1 || page > this.totalPages || this.currentPage === page)
            return;
        this.pageChange.emit(page);
    }

    getDisplayedPages(): (number | "...")[] {
        const pages: (number | "...")[] = [];

        if (this.totalPages <= 7) {
            for (let i = 1; i <= this.totalPages; i++) pages.push(i);
            return pages;
        }

        pages.push(1);

        if (this.currentPage > 4) pages.push("...");

        const start = Math.max(2, this.currentPage - 1);
        const end = Math.min(this.totalPages - 1, this.currentPage + 1);

        for (let p = start; p <= end; p++) {
            pages.push(p);
        }

        if (this.currentPage < this.totalPages - 3) pages.push("...");

        pages.push(this.totalPages);

        return pages;
    }

    changeItemsPerPage(value: number) {
        this.itemsPerPageChange.emit(value);
    }
}
